export default __webpack_public_path__ + "static/transitive-present-bbab62924054b9746ad80d3c0141cbd3.svg";